import { twMerge } from "tailwind-merge";

interface BoxWithShadowProps {
  children: React.ReactNode;
  className?: string;
}

export default function BoxWithShadow({
  children,
  className,
}: BoxWithShadowProps) {
  return (
    <div
      className={twMerge(
        "flex h-full w-full flex-col rounded-lg border border-zinc-200 bg-white p-5 shadow-lg",
        className
      )}
    >
      {children}
    </div>
  );
}
